import { render } from "./CommissionList.vue?vue&type=template&id=054049f1"
import script from "./CommissionList.vue?vue&type=script&lang=js"
export * from "./CommissionList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommissionList.vue?vue&type=style&index=0&id=054049f1&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__